import { isNullOrUndefined } from '@uzurv/rideWss/app/util';

export class LocationUtil {
  static getStreetAddressFromDisplay(display: string): string {
    if (!isNullOrUndefined(display)) {
      return display.substr(0, display.indexOf(','));
    } else {
      return;
    }
  }

  static getCityStateFromDisplay(display: string): string {
    if (!isNullOrUndefined(display)) {
      return display.substr(display.indexOf(',') + 1, display.length - 1);
    } else {
      return;
    }
  }

  static getCityStateZipFromDisplay(display: string): string {
    if (!isNullOrUndefined(display)) {
      const start: number = display.indexOf(',') + 1;
      const length: number = display.lastIndexOf(',') - display.indexOf(',') - 1;
      return display.substr(start, length);
    } else {
      return;
    }
  }

  static getStreetAddressCityStateZipFromDisplay(display: string): string {
    if (!isNullOrUndefined(display)) {
      return display.substr(0, display.lastIndexOf(','));
    } else {
      return;
    }
  }
}
